import { Dispatch, SetStateAction } from 'react'
import { AdvertiserAccessLevel } from '../../../../../generated/graphql'

export interface PrevCursor {
  pageNum: number
  endCursor: string | null
}
export interface QueryVariables {
  after?: string
}

export const getPrevCursor = (pageNum: number, prevCursors: PrevCursor[]): QueryVariables => {
  const prevCursor = prevCursors.filter((prevCursorObj) => prevCursorObj.pageNum === pageNum - 1)
  if (prevCursor[0] && prevCursor[0].endCursor) {
    return { after: prevCursor[0].endCursor }
  }
  return {}
}

export const addNewCursor = (
  prevCursors: PrevCursor[],
  pageNum: number,
  setPrevCursors: Dispatch<SetStateAction<PrevCursor[]>>,
  endCursor: string | null,
): void => {
  const matchedPageNum = prevCursors.filter((prevCursor) => prevCursor.pageNum === pageNum)
  if (matchedPageNum.length === 0) {
    setPrevCursors((prevCursors) => [...prevCursors, { pageNum, endCursor }])
  }
}

// Keep in sync with:
// https://code.amazon.com/packages/AAPNMoshPitLambda/blobs/9584ae2b967d80bc121152ac386ee7513e68c47e/--/src/aapnmoshpitlambda/business/persistence-model-transformers/partner/partner-enum-transforms.ts#L303-L320
// https://code.amazon.com/packages/AAPNMoshPitLambda/blobs/c62b6e38b7c6295e7268e02925bbb75791f3a44e/--/src/aapnmoshpitlambda/business/report/workflow/advertisers-report-workflow.ts#L65-L82
// https://code.amazon.com/packages/AdvertiserUserManagementWebUI/blobs/55d73f87e5abe24576b0e10b4d5974ee585c7ba0/--/src/pages/master-account/linkedAccountTable/types.ts#L3-L13
// https://code.amazon.com/packages/AdvertiserUserManagementWebUI/blobs/030615fa6815a88f79c157c214f0f1d566220a05/--/src/elm/Shared/Types.elm#L218-L223
export const advertiserAccessLevelLabel: Map<AdvertiserAccessLevel, string> = new Map([
  [AdvertiserAccessLevel.EntityOwner, 'ADVERTISERS:TABLE:ACCESS_LEVEL:EDITOR'],
  [AdvertiserAccessLevel.EntityUser, 'ADVERTISERS:TABLE:ACCESS_LEVEL:EDITOR'],
  [AdvertiserAccessLevel.EntityViewer, 'ADVERTISERS:TABLE:ACCESS_LEVEL:VIEWER'],
  [AdvertiserAccessLevel.EntityNoConsoleAccess, 'ADVERTISERS:TABLE:ACCESS_LEVEL:NONE_THIRD_PARTY_APPLICATION'],
  [AdvertiserAccessLevel.SellerUser, 'ADVERTISERS:TABLE:ACCESS_LEVEL:EDITOR'],
  [AdvertiserAccessLevel.DspMaRole, 'ADVERTISERS:TABLE:ACCESS_LEVEL:NONE_DSP'],
  [AdvertiserAccessLevel.ViewPerformanceDashboard, 'ADVERTISERS:TABLE:ACCESS_LEVEL:VIEWER'],
  [AdvertiserAccessLevel.Unknown, 'ADVERTISERS:TABLE:ACCESS_LEVEL:NONE'],
])
